import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { DatePickerEventValue } from '@interstate/components/DatePicker';
import type { InterstateOnChangeEvent } from '@interstate/components/InterstateEvents';
import { formatDate } from '@makemydeal/dr-dash-components';
import * as offerReduxActionCreators from '@makemydeal/dr-dash-store/actions/offerRedux';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

export const useSecondPaymentDateField = () => {
    const dispatch = useDispatch();
    const secondPaymentDate = useSelector(offerReduxSelectors.getSecondPaymentDueDate);
    const isPorscheProRataEnabled = useSelector(featureToggleSelectors.isPorscheProRataEnabled);

    const onChange = useCallback(
        (event: InterstateOnChangeEvent<DatePickerEventValue>) => {
            const value = event.target.value;
            const rawDateValue = value.dateValue;
            const newSecondPaymentDate: string = typeof rawDateValue === 'string' ? rawDateValue : secondPaymentDate;

            if (newSecondPaymentDate) {
                dispatch(offerReduxActionCreators.updateSecondPaymentDueDateField(newSecondPaymentDate, isPorscheProRataEnabled));
            }
        },
        [dispatch, secondPaymentDate, isPorscheProRataEnabled]
    );

    return { value: formatDate(secondPaymentDate), onChange };
};
